/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
const {
  addTabsInCode,
  isNotEquivalent,
} = require('../base-live-demo-component/utils');

const getValueOrDefault = (value, defaultValue) => (value !== '' ? value : defaultValue);

const processCustomColors = (value, defaultColors) => (value !== JSON.stringify(defaultColors, null, 2)
  ? addTabsInCode(
    JSON.stringify(
      isNotEquivalent(
        JSON.parse(value),
        defaultColors,
      ),
      null,
      2,
    ).slice(1, -1),
    10,
  ).replace(/"(\w+)"\s*:/g, '$1:')
  : '');
  
const convertPaymentMethodsPayloadLanguage = (payload, language) => {
  switch (language.toLowerCase()) {
      case 'php':
        const excluded_payment_methods = payload.excluded_payment_methods.map(method => `'id' => '${method?.id}',\n`);
        const excluded_payment_types = payload.excluded_payment_types.map(type => `'id' => '${type?.id}',\n`);
        const installments = payload.installments;

        return `array(
          ${ excluded_payment_methods ? `excluded_payment_methods => array(\n${excluded_payment_methods || ''})` : ''},
          ${ excluded_payment_types ? `excluded_payment_types => array(\n${excluded_payment_types || ''})` : ''},
          ${installments ? `installments => ${installments}` : ''}
        )`;
      case 'java':
        let javaCode = '';

        if (payload.excluded_payment_methods) {
          javaCode += 'List<PreferencePaymentMethodRequest> excludedPaymentMethods = new ArrayList<>();\n';
          payload.excluded_payment_methods.forEach(method => {
              javaCode += `excludedPaymentMethods.add(PreferencePaymentMethodRequest.builder().id("${method.id}").build());\n`;
          });
          }
      
          if (payload.excluded_payment_types) {
              javaCode += '\nList<PreferencePaymentTypeRequest> excludedPaymentTypes = new ArrayList<>();\n';
              payload.excluded_payment_types.forEach(type => {
                  javaCode += `excludedPaymentTypes.add(PreferencePaymentTypeRequest.builder().id("${type.id}").build());\n`;
              });
          }
  
          return javaCode;
      case 'ruby':
          payload
      case 'c#':
          let csCode = '';
  
          if (payload.excluded_payment_methods) {
            csCode += 'excludedPaymentMethods = new List<PreferencePaymentMethodRequest> {\n';
            payload.excluded_payment_methods.forEach(method => {
                csCode += `new PreferencePaymentMethodRequest
                {
                    Id = "${method.id}",
                },\n`;
            });
            csCode += '};\n';
            }
        
            if (payload.excluded_payment_types) {
                csCode += 'ExcludedPaymentTypes = new ArrayList<>();\n';
                payload.excluded_payment_types.forEach(method => {
                  csCode += `new PreferencePaymentTypeRequest
                  {
                      Id = "${method.id}",
                  },\n`;
              });
              csCode += '};\n';
            }
    
            return csCode;
      case 'python':
          return JSON.stringify(payload, null, 2).replace(/:/g, ' :').replace(/[{]/g, '{').replace(/[}]/g, '}').replace(/\\"/g, '"');
      default:
          return payload;
  }
}

const getPaymentMethodsPayload = (paymentParams) => {
  const { paymentMethodDebitCardType, paymentMethodCreditCardType, maxInstallments, publicKey, credit_card, debit_card } = paymentParams;

  const paymentMethodsAndTypesByPublicKey = {
    'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b': {
      payment_types: ['ticket', 'credit_card', 'debit_card', 'ticket'],
      generic_payment_methods: [],
      payment_methods_credit_card: ['amex', 'master', 'visa', 'argencard', 'cabal', 'cmr', 'cencosud', 'cordobesa', 'diners', 'naranja', 'tarshop'],
      payment_methods_debit_card: ['debcabal', 'maestro', 'debmaster', 'debvisa'],
    },
    'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d': {
      payment_types: ['credit_card', 'debit_card_caixa'],
      generic_payment_methods: ['pix', 'bolbradesco', 'pec'],
      payment_methods_credit_card: ['amex', 'master', 'visa', 'elo', 'hipercard'],
      payment_methods_debit_card: [],
    },
    'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8': {
      payment_types: ['credit_card', 'debit_card', 'bank_transfer', 'ticket'],
      generic_payment_methods: [],
      payment_methods_credit_card: ['amex', 'master', 'visa'],
      payment_methods_debit_card: ['debmaster', 'debvisa', 'redcompra'],
    },
    'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5': {
      payment_types: ['credit_card', 'debit_card', 'ticket'],
      generic_payment_methods: [],
      payment_methods_credit_card: ['amex', 'master', 'visa', 'creditel', 'oca'],
      payment_methods_debit_card: ['debmaster', 'debvisa'],
    },
    'TEST-af696d89-c335-4cc1-982c-af28f38e7894': {
      payment_types: ['credit_card', 'debit_card', 'ticket'],
      generic_payment_methods: [],
      payment_methods_credit_card: ['amex', 'master', 'visa', 'codensa'],
      payment_methods_debit_card: ['debmaster', 'debvisa'],
    },
    'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13': {
      payment_types: ['credit_card', 'debit_card'],
      generic_payment_methods: ['pagoefectivo_atm'],
      payment_methods_credit_card: ['amex', 'master', 'visa', 'diners'],
      payment_methods_debit_card: ['debmaster', 'debvisa'],
    },
    'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad': {
      payment_types: ['credit_card', 'debit_card'],
      generic_payment_methods: ['pagoefectivo_atm', 'bancaInternet', 'pagoefectivo_atm'],
      payment_methods_credit_card: ['amex', 'master', 'visa'],
      payment_methods_debit_card: ['debmaster', 'debvisa'],
    },
  };

  const mapPaymentMethodDebitCard = (method => {
    switch (method) {
      case 'debit_card_caixa':
        return 'debit_card';
      default:
        return method;
    }
  });

  const countryPaymentsMethodsAndTypes = paymentMethodsAndTypesByPublicKey[publicKey] || {};
  const countryPaymentMethodsCreditCard = countryPaymentsMethodsAndTypes.payment_methods_credit_card || [];
  const countryPaymentMethodsDebitCard = countryPaymentsMethodsAndTypes.payment_methods_debit_card || [];
  const countryPaymentTypes = countryPaymentsMethodsAndTypes.payment_types || [];

  const getExcludePaymentTypes = () => {
    const filterSelectedPaymentTypes = (paymentType) => {
      switch (paymentType) {
        case 'credit_card':
          return !credit_card;
        case 'debit_card':
          return !debit_card;
        default:
          return !paymentParams[paymentType];
      }
    };

    return [...new Set(countryPaymentTypes
      .filter(filterSelectedPaymentTypes)
      .map(mapPaymentMethodDebitCard))];
  };

  const getExcludePaymentMethods = () => {
    const excludedCountryPaymentMethodsCreditCard = countryPaymentMethodsCreditCard.filter(method => !paymentMethodCreditCardType?.includes(method));
    const excludedcountryPaymentMethodsDebitCard = countryPaymentMethodsDebitCard.filter(method => !paymentMethodDebitCardType?.includes(method)) || [];
    const excludedGenericPaymentMethods = countryPaymentsMethodsAndTypes.generic_payment_methods?.filter(method => !paymentParams[method]) || [];
    const result = [];
    if (credit_card) result.push(...excludedCountryPaymentMethodsCreditCard);
    if (debit_card) result.push(...excludedcountryPaymentMethodsDebitCard);
    result.push(...excludedGenericPaymentMethods);

    return [...new Set(result)];
  };

  const excludedPaymentTypes = getExcludePaymentTypes();
  const excludedPaymentMethods = getExcludePaymentMethods();

  const payload = {
    excluded_payment_methods: excludedPaymentMethods.map(method => ({ id: method })),
    excluded_payment_types: excludedPaymentTypes.map(type => ({ id: type })),
    installments: maxInstallments || 12,
  };

  return payload;
};

const users = [
  {
    user: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d',
    country: 'BR',
    locale: 'pt-BR',
    items: ['credit_card', 'debit_card', 'ticket', 'bank_transfer', 'onboarding_credits', 'wallet_purchase'],
    accessToken: 'TEST-7434002853288159-031415-e93f0f4cee51edf8c90ff795af94f589-1322442691',
  },
  {
    user: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b',
    country: 'AR',
    locale: 'es-AR',
    items: ['credit_card', 'debit_card', 'ticket', 'onboarding_credits', 'wallet_purchase'],
    accessToken: 'TEST-4599991948843755-112216-0171268d497ae962d904f4a27ecf8d85-1245621468',
  },
  {
    user: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5',
    country: 'UY',
    locale: 'es-UY',
    items: ['credit_card', 'debit_card', 'ticket', 'wallet_purchase'],
    accessToken: 'TEST-3322631766806190-030312-1cd04b846528954cf9acbb4ba0339910-1322460166',
  },
  {
    user: 'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13',
    country: 'CL',
    locale: 'es-CL',
    items: ['credit_card', 'debit_card', 'bank_transfer', 'wallet_purchase'],
    accessToken: 'TEST-7719716762635832-031414-b2f72b0ec93098549c6616b21f1e54b5-1269022120',
  },
  {
    user: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8',
    country: 'MX',
    locale: 'es-MX',
    items: ['credit_card', 'debit_card', 'ticket', 'bank_transfer', 'onboarding_credits', 'wallet_purchase'],
    accessToken: 'TEST-8971847217814918-011912-8ad91745874530a4ca8b8992d4799fdf-1283156318',
  },
  {
    user: 'TEST-af696d89-c335-4cc1-982c-af28f38e7894',
    country: 'CO',
    locale: 'es-CO',
    items: ['credit_card', 'debit_card', 'ticket', 'bank_transfer', 'wallet_purchase'],
    accessToken: 'TEST-5599114831530291-021714-7a29539139a4791edcd709f06f7f5835-1312670102',
  },
  {
    user: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad',
    country: 'PE',
    locale: 'es-PE',
    items: ['credit_card', 'debit_card', 'atm', 'wallet_purchase'],
    accessToken: 'TEST-2151654715776762-030312-3442d75750b665b753ab6d2034dac477-1322465684',
  },
];

const formatPaymentMethodsPayloadToString = (formData, returnRawObject = false) => {
  const paymentMethods = {
    paymentMethodCreditCardType: formData?.paymentMethodCreditCardType,
    paymentMethodDebitCardType: formData?.paymentMethodDebitCardType,
    maxInstallments: formData?.maxInstallments,
    credit_card: formData?.credit_card,
    pix: formData?.pix,
    pec: formData?.pec,
    bolbradesco: formData?.bolbradesco,
    debit_card_caixa: formData?.debit_card_caixa,
    debit_card: formData?.debit_card,
    ticket: formData?.ticket,
    pagoefectivo_atm: formData?.pagoefectivo_atm,
    bancaInternet: formData?.bancaInternet,
    publicKey: formData?.publicKey,
    bank_transfer: formData?.bank_transfer,
  };

  const payload = getPaymentMethodsPayload(paymentMethods);

  if (returnRawObject) return payload;

  return JSON.stringify(
    payload,
    null,
    12,
  )?.replace(/"(\w+)"\s*:/g, '$1:');
};

module.exports = { getValueOrDefault, processCustomColors, getPaymentMethodsPayload, users, formatPaymentMethodsPayloadToString, convertPaymentMethodsPayloadLanguage };
